import { SORT_BY_BEST_MATCH } from '../constants/sorting';
import { getPostSorting } from './app-settings-selectors';
import { get } from 'lodash';

export const getCategoryPageSorting = state =>
  get(state, 'sorting.categoryPage', getPostSorting(state));

export const getSearchPageSorting = state => get(state, 'sorting.searchPage', SORT_BY_BEST_MATCH);
